import { render, staticRenderFns } from "./TCsSpark.vue?vue&type=template&id=22ae1335"
import script from "./TCsSpark.vue?vue&type=script&lang=js"
export * from "./TCsSpark.vue?vue&type=script&lang=js"
import style0 from "./TCsSpark.vue?vue&type=style&index=0&id=22ae1335&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports